import React from 'react';
import SvgIcon from '../../images/ilustrations/Anye_azucar_new.svg';

const AnyeAzucar = () => (
    <img src={SvgIcon} alt="Azúcar" style={{ width: '2em', height: '2em' }} />
);

export default AnyeAzucar;
